import { useEffect, useId, useState } from 'react';

/** Retains the last valid value while a bounded numeric field is being edited. */
export function PrecisionControl({ label, inputLabel, value, min, max, step = 1, disabled = false, onChange, invalidMessage, integer = false, externalValue = false }: {
  label: string; inputLabel?: string | undefined; value: number; min: number; max: number; step?: number; disabled?: boolean; onChange: (value: number) => void; invalidMessage?: string | undefined; integer?: boolean; externalValue?: boolean;
}) {
  const [text, setText] = useState(String(value));
  const id = useId();
  useEffect(() => setText(String(value)), [value]);
  const number = Number(text);
  const invalid = text.trim() === '' || !Number.isFinite(number) || number < min || number > max || (integer && !Number.isInteger(number));
  const invalidEdit = invalid && !(externalValue && number === value);
  return <span className="precision-control">
    <input type="number" inputMode="decimal" aria-label={inputLabel ?? `${label} value`} min={min} max={max} step={step} disabled={disabled}
      value={text} aria-invalid={invalidEdit} aria-describedby={invalidEdit ? id : undefined} onChange={event => {
        const next = event.target.value; setText(next);
        const parsed = Number(next);
        if (next.trim() && Number.isFinite(parsed) && parsed >= min && parsed <= max && (!integer || Number.isInteger(parsed))) onChange(parsed);
      }} onBlur={() => { if (invalid) setText(String(value)); }}
      onKeyDown={event => { if (event.key === 'Enter') event.currentTarget.blur(); }} />
    {invalidEdit && <small id={id}>{invalidMessage ?? `Enter ${min}–${max}. The last valid value remains active.`}</small>}
  </span>;
}
